export default {
  invalidEmail:                   'invalidEmail',
  invalidFormat:                  'invalidFormat',
  invalidPhoneFormat:             'invalidPhoneFormat',
  invalidCifFormat:               'invalidCifFormat',
  invalidDniFormat:               'invalidDniFormat',
  invalidAsciiAlphanumericFormat: 'invalidAsciiAlphanumericFormat',

  minOneRequired:                       'minOneRequired',
  minOneContactRequired:                'minOneContactRequired',
  minOneProcessPairRequired:            'minOneProcessPairRequired',
  minOneEducationalAchievementRequired: 'minOneEducationalAchievementRequired',
  minOneExperienceRequired:             'minOneExperienceAchievementRequired',

  min1:             'min1',
  required:         'required',
  min8Chars:        'min8Chars',
  mustBeIdentical:  'mustBeIdentical',
  max32:            'max32',
  max256:           'max256',
  hasToBeAnInteger: 'hasToBeAnInteger',
}



// WEBPACK FOOTER //
// ./src/components/forms/form-utils/i18n-error-ids.ts